<div class="feed-content">
  <img class="tw-max-w-[500px] tw-block tw-m-auto" [src]="feed?.url" (click)="onLikeClick()" [width]="style.width" />
  @if (playLikeAnimation) {
    <i class="cs-icon-favorite"></i>
  }
</div>